import { render } from "./PromoView.vue?vue&type=template&id=0c5b1a9a"
import script from "./PromoView.vue?vue&type=script&lang=js"
export * from "./PromoView.vue?vue&type=script&lang=js"

import "./PromoView.vue?vue&type=style&index=0&id=0c5b1a9a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__